// XNGAGE CONFIDENTIAL
// __________________________

//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { titleTypographyStyles } from "@awc/App/Components/Common/TitleTypography";
import ChevronRight from "@awc/XDL/Icons/ChevronRight";
import { createLinkIconStyles, getSystemColor, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

titleTypographyStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 12px;
        ${xScreen("lte", "sm")} {
            gap: 10px;
            justify-content: space-between;
        }
    `,
};

titleTypographyStyles.title = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
        ${xScreen("lte", "sm")} {
            margin-right: 0;
        }
    `,
};

titleTypographyStyles.link = {
    ...createLinkIconStyles({
        icon: ChevronRight,
        linkStyles: {
            color: getSystemColor("common.ui4"),
            hoverStyle: {
                color: getSystemColor("common.ui8"),
            },
            icon: {
                position: "right",
            },
            css: css`
                margin-left: auto;
                ${xScreen("lte", "sm")} {
                    margin-left: 0;
                }
                &:focus {
                    outline: none;
                }
                align-items: center;
            `,
        },
        sizeVariant: "large",
    }),
};
titleTypographyStyles.buttonStyles = {
    css: css`
        margin-left: auto;
        ${xScreen("lte", "sm")} {
            margin-left: 0;
        }
    `,
};
